// extracted by mini-css-extract-plugin
export default {"wrapper":"error-view_wrapper__TPYqq","error-code":"error-view_error-code__f3ZhZ","heading":"error-view_heading__SgUfT","button":"error-view_button__8-+5c"};